import { map } from "lodash";

export const paymentTerms = map(
  {
    DAYSAFTERBILLDATE: "day(s) after bill date",
    DAYSAFTERBILLMONTH: "day(s) after bill month",
    OFCURRENTMONTH: "of the current month",
    OFFOLLOWINGMONTH: "of the following month",
  },
  (label, value) => ({ value, label })
);
